export const VERIFICATION_CODE_PATTERN = /^[A-NP-Z1-9]{6}$/i;

export const verificationCodeValidationMessages = {
  expired: 'Code expired.',
  pattern: 'Incorrect code. Please try again.',
  required: 'Enter the code we sent to your email.',
} as const;

export const verificationCodeValidations = {
  pattern: {
    message: verificationCodeValidationMessages.pattern,
    value: VERIFICATION_CODE_PATTERN,
  },
  required: verificationCodeValidationMessages.required,
};
